"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Poll = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Poll_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1c-.69 0-1.25.56-1.25 1.25v11.5c0 .69.56 1.25 1.25 1.25h2c.69 0 1.25-.56 1.25-1.25V2.25C10.25 1.56 9.69 1 9 1H7Zm2 1H7a.25.25 0 0 0-.25.25v11.5c0 .138.112.25.25.25h2a.25.25 0 0 0 .25-.25V2.25A.25.25 0 0 0 9 2ZM1.25 8C.56 8 0 8.56 0 9.25v4.5C0 14.44.56 15 1.25 15h2c.69 0 1.25-.56 1.25-1.25v-4.5C4.5 8.56 3.94 8 3.25 8h-2Zm2 1h-2a.25.25 0 0 0-.25.25v4.5c0 .138.112.25.25.25h2a.25.25 0 0 0 .25-.25v-4.5A.25.25 0 0 0 3.25 9ZM11.5 5.25c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25v-8.5ZM12.75 5h2a.25.25 0 0 1 .25.25v8.5a.25.25 0 0 1-.25.25h-2a.25.25 0 0 1-.25-.25v-8.5a.25.25 0 0 1 .25-.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Poll_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Poll;
exports["default"] = _default;